// Documents Needed page component
export function DocumentsNeededPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">Required Documents</h1>
    <p class="hero-subtitle">Prepare these documents to speed up the certification process</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="bg-blue-50 border-l-4 border-blue-500 p-6 mb-12 rounded-lg">
      <h3 class="text-lg font-bold text-blue-900 mb-2 flex items-center">
        <span class="mr-2">📋</span>Essential Documents
      </h3>
      <p class="text-blue-700">These documents are required to prepare the EPC certificate for your property</p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">

      <div class="card border-l-4 border-red-500">
        <div class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Mandatory</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">📄</span>Title Deed or Cadastral Certificate
        </h3>
        <p class="text-gray-600 mb-4">To verify the exact surface area of the property</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Usable and built surface area</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Property description</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Year of construction</li>
        </ul>
      </div>

      <div class="card border-l-4 border-red-500">
        <div class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Mandatory</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🆔</span>Owner’s ID
        </h3>
        <p class="text-gray-600 mb-4">Identification of the property owner</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Valid identification document</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Clear and legible copy</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Front and back sides</li>
        </ul>
      </div>

      <div class="card border-l-4 border-green-500">
        <div class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Recommended</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🏗️</span>Construction Project
        </h3>
        <p class="text-gray-600 mb-4">If you have the original project or renovation documentation</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Property floor plans</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Descriptive report</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Technical specifications</li>
        </ul>
      </div>

      <div class="card border-l-4 border-green-500">
        <div class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Recommended</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">⚡</span>Energy Bills
        </h3>
        <p class="text-gray-600 mb-4">To validate actual energy consumption</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Electricity (last year)</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Gas (last year)</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Diesel/Propane if applicable</li>
        </ul>
      </div>

      <div class="card border-l-4 border-yellow-500">
        <div class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Optional</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🔧</span>Installation Certificates
        </h3>
        <p class="text-gray-600 mb-4">If you have certificates for boiler, air conditioning, etc.</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Boiler or water heater</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Air conditioning</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Electrical installation</li>
        </ul>
      </div>

      <div class="card border-l-4 border-yellow-500">
        <div class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium mb-4">Optional</div>
        <h3 class="text-xl font-bold text-gray-900 mb-3 flex items-center">
          <span class="mr-2">🌞</span>Renewable Energy Systems
        </h3>
        <p class="text-gray-600 mb-4">Documentation of installed renewable energy systems</p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Solar panels</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Aerothermal heat pump</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Geothermal energy</li>
        </ul>
      </div>

    </div>
  </div>
</section>
<section class="section bg-gray-50">
  <div class="container max-w-4xl mx-auto">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Checklist</h2>
    <div class="grid md:grid-cols-2 gap-8">

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-6 flex items-center">
          <span class="mr-2">✅</span>Before the Visit
        </h3>
        <div class="space-y-4">
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="escrituras" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Title deeds or cadastral certificate</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="dni" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Owner’s ID (copy)</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="facturas" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Electricity and gas bills from the last year</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="acceso" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Ensure access to all rooms</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="llaves" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Keys for meters and electrical panels</span>
          </label>
        </div>
      </div>

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-6 flex items-center">
          <span class="mr-2">📂</span>If Available
        </h3>
        <div class="space-y-4">
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="planos" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Property floor plans</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="proyecto" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Original construction project</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="reforma" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Renovation documentation</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="certificados" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Equipment certificates</span>
          </label>
          <label class="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" id="renovables" class="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500">
            <span class="text-gray-700">Renewable energy documentation</span>
          </label>
        </div>
      </div>

    </div>
  </div>
</section>


<section class="section bg-white">
  <div class="container">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Missing Some Documents?</h2>
    <div class="grid md:grid-cols-2 gap-8">

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">🔍</span>We Can Help
        </h3>
        <p class="text-gray-600 mb-4">If you are missing any documents, our technician can:</p>
        <ul class="space-y-2 text-gray-600">
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Carry out on-site measurements</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Consult official databases</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Estimate data according to regulations</li>
          <li class="flex items-center"><span class="text-green-500 mr-2">✓</span>Advise you on obtaining documents</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-xl font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">📋</span>Alternatives
        </h3>
        <p class="text-gray-600 mb-4">For cases without documentation:</p>
        <ul class="space-y-2 text-gray-600">
          <li><span class="font-semibold">Cadastral certificate:</span> Cadastre (≈ €9)</li>
          <li><span class="font-semibold">Utility bills:</span> Request them from the energy supplier</li>
          <li><span class="font-semibold">Floor plans:</span> Local architects’ association</li>
          <li><span class="font-semibold">Certificates:</span> Installation company</li>
        </ul>
      </div>

    </div>
  </div>
</section>


<section class="section bg-gray-50">
  <div class="container">
    <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Preparation Tips</h2>

    <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">🏠</span>Access to the Property
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>All rooms accessible</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Terrace/balcony cleared</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Storage rooms and attics if included</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Garage if included in the surface area</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">⚡</span>Installations
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Locate electrical panel</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Access to meters</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Utility cupboards</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Access to boiler/water heater</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">📝</span>Useful Information
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Year of construction</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Renovations carried out and dates</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Changes to installations</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Known issues (dampness, etc.)</li>
        </ul>
      </div>

      <div class="card">
        <h3 class="text-lg font-bold text-gray-900 mb-4 flex items-center">
          <span class="mr-2">⏰</span>During the Visit
        </h3>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Presence of the owner or representative</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Estimated duration: 1–3 hours</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>The technician must take photographs</li>
          <li class="flex items-center"><span class="text-blue-500 mr-2">•</span>Possible questions about property use</li>
        </ul>
      </div>

    </div>

    <h3 class="text-2xl font-bold text-center text-gray-900 mb-8">Frequently Asked Questions</h3>

    <div class="space-y-6 max-w-3xl mx-auto">

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">What happens if I don’t have the title deeds?</h4>
        <p class="text-gray-600">You can request a cadastral certificate from the Cadastre for around €9. We can also proceed with direct measurements, although this is less precise.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">Are energy bills required?</h4>
        <p class="text-gray-600">They are not mandatory, but they help validate theoretical calculations against actual consumption, improving the accuracy of the certificate.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">What if I am a tenant?</h4>
        <p class="text-gray-600">You need authorization from the owner and a copy of their identification. The owner must be informed and give permission for the certification.</p>
      </div>

      <div class="card">
        <h4 class="text-lg font-semibold text-gray-900 mb-2">Can I send the documents by email?</h4>
        <p class="text-gray-600">Yes, you can send digital copies before the visit. The technician can also review them during the inspection if you prefer.</p>
      </div>

    </div>
  </div>
</section>


<section class="section bg-blue-600 text-white">
  <div class="container text-center">
    <h2 class="text-3xl font-bold mb-4">Everything Ready?</h2>
    <p class="text-xl mb-8 opacity-90">With your documentation prepared, the process is faster and more accurate</p>
    <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/book-epc/">Book EPC Certificate</button>
  </div>
</section>


  `;
}
